module.exports = __webpack_public_path__ + "img/C2.3d2e56b3.jpg";